import React, { useState } from "react";
import { Modal, Tabs, Input, Button, Upload, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import emailCampaignApi from "../../../api/emailCampaignApi";

/**
 * Modal chèn ảnh vào Quill editor — hỗ trợ cả URL và tải lên file.
 * Backend trả URL tuyệt đối (dựa trên API_PUBLIC_URL env), không cần prefix thêm ở frontend.
 *
 * Props:
 *   open: boolean
 *   onClose: () => void
 *   onInsert: (url: string) => void  — gọi với URL tuyệt đối để chèn vào editor
 */
function EmailImageInsertModal({ open, onClose, onInsert }) {
    const [tab, setTab] = useState("url");
    const [urlInput, setUrlInput] = useState("");
    const [uploading, setUploading] = useState(false);

    const handleInsertUrl = () => {
        const url = urlInput.trim();
        if (!url) { message.warning("Nhập URL ảnh"); return; }
        onInsert(url);
        setUrlInput("");
        onClose();
    };

    const handleUpload = async ({ file }) => {
        try {
            setUploading(true);
            const { data } = await emailCampaignApi.uploadImage(file);
            // Backend đã trả URL tuyệt đối khi API_PUBLIC_URL được config
            onInsert(data.data.url);
            onClose();
        } catch (err) {
            message.error(err?.response?.data?.message || "Tải lên thất bại");
        } finally {
            setUploading(false);
        }
    };

    return (
        <Modal
            title="Chèn ảnh"
            open={open}
            onCancel={onClose}
            footer={null}
            width={420}
            destroyOnClose
        >
            <Tabs
                activeKey={tab}
                onChange={setTab}
                items={[
                    {
                        key: "url",
                        label: "Từ URL",
                        children: (
                            <div className="flex flex-col gap-3 pt-2">
                                <Input
                                    placeholder="https://example.com/image.jpg"
                                    value={urlInput}
                                    onChange={(e) => setUrlInput(e.target.value)}
                                    onPressEnter={handleInsertUrl}
                                    autoFocus
                                />
                                <Button type="primary" onClick={handleInsertUrl} block>
                                    Chèn ảnh
                                </Button>
                            </div>
                        ),
                    },
                    {
                        key: "upload",
                        label: "Tải lên",
                        children: (
                            <div className="pt-2">
                                <Upload.Dragger
                                    accept="image/*"
                                    showUploadList={false}
                                    customRequest={handleUpload}
                                    disabled={uploading}
                                >
                                    <p className="text-3xl mb-2">
                                        <FontAwesomeIcon icon={faUpload} />
                                    </p>
                                    <p className="text-sm">
                                        {uploading ? "Đang tải lên..." : "Kéo thả hoặc nhấn để chọn ảnh"}
                                    </p>
                                    <p className="text-xs text-content-3 mt-1">JPG, PNG, GIF — tối đa 5MB</p>
                                </Upload.Dragger>
                            </div>
                        ),
                    },
                ]}
            />
        </Modal>
    );
}

export default EmailImageInsertModal;
